import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

const initialState = {
  locationId: '',
  dashboard: '',
  inbound: '',
  putaway: '',
  bulk_putaway: '',
  transfer: '',
  stock: '',
  outbound: '',
  bulkoutbound: '',
  packing: '',
  picking: '',
  bulkpicking: '',
  bulkpacking: '',
  shippingScan: '',
  carrier: '',
  machine: 'all',
  packingMaterial: 'all',
  sorter: 'all',
  mapping: '',
  locationManagement: 'all',
  returnInbound: '',
  returnInboundScanTracking: '',
  adjustment_tasks: '',
};

const store = (set, get) => ({
  ...initialState,

  setDefaultLocationId: (value) => {
    set({ locationId: value });
  },
  setLocationId: (page, value) => {
    set((prev) => ({ ...prev, [page]: value }));
  },

  getLocationId: (page) => {
    const pageLocation = get()[page];
    if (pageLocation !== undefined && pageLocation !== '') {
      return pageLocation;
    }
    return get().locationId || '';
  },
  reset: () => {
    set(initialState);
  },
});

const locationStore = create(
  persist(store, {
    name: 'location',
    storage: createJSONStorage(() => localStorage),
  }),
);

export default locationStore;
